import Icon from "../ui/Icon.jsx";
import { readError } from "../errors.js";

/** 화면을 그릴 수 없을 때. 서버가 준 문구가 있으면 그걸 그대로 쓴다. */
export default function Broken({ err, message, onRetry, retryLabel = "다시 시도" }) {
  const { title, hint } = readError(err, message);

  return (
    <main className="screen">
      <div className="bar">
        <span className="logo">그래서요<span className="q">?</span></span>
      </div>
      <div className="center-screen">
        <div className="card alert raised" style={{ maxWidth: 520, textAlign: "left" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 9 }}>
            <Icon name="warn" size={22} stroke="currentColor" width={2.8} />
            <h1 className="d" style={{ fontSize: 25, lineHeight: 1.2 }}>{title}</h1>
          </div>
          {hint && <p style={{ fontSize: 14, fontWeight: 700, lineHeight: 1.55 }}>{hint}</p>}
        </div>
        {onRetry && (
          <button type="button" className="btn primary" onClick={onRetry}>
            {retryLabel}
          </button>
        )}
      </div>
    </main>
  );
}
